import 'react-toastify/dist/ReactToastify.css';
import AppContextProvider from './AppContextProvider';
import AppRouting from './AppRouting';

const App = () => {
  //
  // Main render
  //
  return (
    <AppContextProvider>
      <AppRouting />
    </AppContextProvider>
  );
};

export default App;
